export default <UiState>{
  darkMode: false,
  navbarVariant: 'navbar-blue',
  sidebarSkin: 'bg-light',
  menuSidebarCollapsed: false,
  controlSidebarCollapsed: true
  // screenSize: calculateWindowSize(window.innerWidth)
};

export interface UiState {
  darkMode: boolean;
  menuSidebarCollapsed: boolean;
  controlSidebarCollapsed: boolean;
  navbarVariant: string;
  sidebarSkin: string;
  screenSize: any;
}
